import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { EmailVerificationBanner } from './EmailVerificationBanner'

interface RootLayoutProps {
  children: React.ReactNode
}

export function RootLayout({ children }: RootLayoutProps) {
  return (
    <div className="flex h-screen bg-[var(--oc-bg)] overflow-hidden">
      <Sidebar />
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Topbar />
        <EmailVerificationBanner />
        <main className="flex-1 overflow-y-auto p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  )
}
